import React from 'react';

import { i18n } from 'config/locales';

import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Subsection from 'components/Section/shared/Subsection';
import { FINANCIAL } from 'config/formSections/financial';
import { Summary, DateSummary } from 'components/Summary';
import Branch from 'components/Form/Branch';
import Accordion from 'components/Form/Accordion';
import NotApplicable from 'components/Form/NotApplicable';
import { FINANCIAL_ALIMONY } from 'config/formSections/financial';
import { EmptyListInstance } from 'forms/shared/models';
import { EmptyBranch } from 'forms/shared/validators/models/branch/instance';
import AlimonyItem from './AlimonyItem';

const sectionConfig = {
  key: FINANCIAL_ALIMONY.key,
  section: FINANCIAL.name,
  store: FINANCIAL.store,
  subsection: FINANCIAL_ALIMONY.name,
  storeKey: FINANCIAL_ALIMONY.storeKey,
};

export class Alimony extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      HasAlimony: this.props.HasAlimony,
      HasAlimonyNotApplicable: this.props.HasAlimonyNotApplicable,
      List: this.props.List,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateHasAlimony = (values) => {
    this.update({
      HasAlimony: values,
      List: values?.value === 'Yes' ? this.props.List : { items: [], branch: {} },
    });
  };

  updateHasAlimonyNotApplicable = (values) => {
    const isApplicable = values?.applicable;
    this.update({
      HasAlimonyNotApplicable: values,
      HasAlimony: isApplicable ? this.props.HasAlimony : EmptyBranch(),
      List: isApplicable ? this.props.List : EmptyListInstance,
    });
  };

  /**
     * Assists in rendering the summary section.
     */
  summary = (item, index) => {
    const b = item.Item || {};
    const from = DateSummary(b.DateFiled);

    return Summary({
      type: i18n.t('financial.pvq.alimony.collection.summary.item'),
      index,
      left: '',
      right: from,
      placeholder: i18n.t('financial.pvq.alimony.collection.summary.unknown'),
    });
  };

  render() {
    const {
      errors,
      required,
      scrollIntoView,
      scrollToBottom,
      defaultState,
      dispatch
    } = this.props;

    const accordionErrors = errors && errors.filter((e) => e?.indexOf?.('List.accordion') === 0);
    return (
      <div
        className="section-content alimony"
        data-section={FINANCIAL.key}
        data-subsection={FINANCIAL_ALIMONY.key}
      >
        <h1 className="section-header">{i18n.t('financial.pvq.destination.alimony')}</h1>
        <NotApplicable
          {...this.props.HasAlimonyNotApplicable}
          label={i18n.t('financial.pvq.shared.na')}
          attribute="HasAlimonyNotApplicable"
          onUpdate={this.updateHasAlimonyNotApplicable}
          scrollIntoView={this.props.scrollIntoView}
          required={this.props.required}
          useChangeWarning
        >
          <Branch
            name="has_alimony"
            label={i18n.t('financial.pvq.alimony.branch.title')}
            labelSize="h4"
            className="alimony-branch"
            {...this.props.HasAlimony}
            warning
            onUpdate={this.updateHasAlimony}
            required={required}
            scrollIntoView={scrollIntoView}
            onError={this.handleError}
            attribute="HasAlimony"
          />
        </NotApplicable>
        {this.props.HasAlimony?.value === 'Yes' && (
          <Accordion
            {...this.props.List}
            defaultState={defaultState}
            scrollToBottom={scrollToBottom}
            onUpdate={this.updateList}
            summary={this.summary}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            required={required}
            errors={accordionErrors}
            scrollIntoView={scrollIntoView}
            appendTitle={i18n.t('financial.pvq.alimony.appendTitle')}
            attribute="List"
          >
            <AlimonyItem
              name="Item"
              dispatch={dispatch}
              bind
              required={required}
              scrollIntoView={scrollIntoView}
              attribute="List"
            />
          </Accordion>
        )}
      </div>
    );
  }
}

Alimony.defaultProps = {
  onUpdate: () => {},
  onError: (value, arr) => arr,
  dispatch: () => {},
  defaultState: true,
  scrollToBottom: '.bottom-btns',
  errors: [],
};

export default connectSubsection(Alimony, sectionConfig);
